export const MARKET_TEMPERATURE_CONSTANTS = {
  BUYER_MARKET_THRESHOLD: 40,
  BALANCED_MARKET_THRESHOLD: 60,
  COVERAGE_SCORE_THRESHOLD: 30,
  MARKET_TEMP_MIN: 7,
  MARKET_TEMP_MAX: 91
} as const
